export default __webpack_public_path__ + "static/media/chart-trades.cda7d37a.png";